import React, { PureComponent ,useState,useEffect,useRef} from "react";
import { Form ,Button,Col,Row, message,Modal ,Input ,Select ,Radio,Space,DatePicker} from 'antd';
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getCurrentUser } from 'utils/storage';
import moment from 'moment'
import zh_CN from 'antd/lib/date-picker/locale/zh_CN'
import { getDict } from "@/utils/storage";
import 'moment/locale/zh-cn'
import {getStatus} from '@/utils/methods';
import ApproveModal from '@/components/ApproveModal'
import {getcodeValue } from "@/utils/storage"
moment.locale('zh-cn')
const FormItem  = Form.Item
const { TextArea } = Input
const { Option } = Select
require ("./createAssistItem.scss");

const list = [
            {
              label: "申请人",
              name: "epalFinanceName",
              value:"",
              type: "input",
              require: true,
              placeholder: "请输入姓名"
            },
            {
              label: "联系电话",
              name: "epalFinanceTel",
              value:"",
              type: "input",
              require: true,
              placeholder: "请输入身份证"
            },

            {
              label: "身份证号码",
              name: "epalFinanceCard",
              value:"",
              type: "input",
              require: true,
              placeholder: "请选择奖是否成立公司"
            },
            {
              label: "产品名称",
              name: "epalProductName",
              value:"",
              type: "input",
              require: true,
              placeholder: "请输入公司名称"
            },
            {
              label: "产品类别",
              name: "epalProductType",
              value:"",
              type: "select",
              require: true,
              placeholder: "请输入公司名称"
            },
            {
              label: "申请时间",
              name: "epalFinanceDate",
              value:"",
              type: "time",
              require: true,
              placeholder: "请输入公司名称"
            },
  
        ]
export default function DeucationTrainingPolicyDetail (props){
  const [form] = Form.useForm();
  const [sourseId, setSourseId] = useState("")
  const [courseInfo, setCourseInfo] = useState({})
  const [modalVisible, setModalVisible] = useState(false)
  const [checkValue, setCheckValue] = useState(1)
  const history = useHistory()
  const modalRef = useRef([])
  useEffect(()=>{
    let sourseId = props.location.pathname.split('/').slice(-1)
      getDetail(sourseId[0])
      setSourseId(sourseId[0])
  },[])
    //获取详情
    const getDetail = (data) =>{
      console.log('id信息',data);
      let params = {
          id : data
      }
      Http.getApplication(Request.financialDetail(),{...params},(obj)=>{
          console.log(obj);
          if(obj.code == 200){
            setCourseInfo(obj.data)
            console.log('formformformformform',form);
            
          }
     })
  }
  const showModal = (e) => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1
    });
    if(!getCurrentUser()){
      message.error("还未登录，请先登录后再申请！");
      history.push("/login");
      return;
    }
    if(getCurrentUser().user_type!='2'){
      message.warn("非退役军人不可申请!")
      return;
    }
    getStatus().then(res=>{
    if(res===false){
      modalRef.current.showModal();
      return;
    }
    e.stopPropagation()
    setModalVisible(true)
    })
  }
  const handleOk = (e) => {
    // console.log('eeeeeeeeeeee',form);
    // form.validateFields().then(
    //   values => {
    //     /*
    //   values:
    //     {
    //       username: 'username',
    //       password: 'password',
    //     }
    //   */
    //  console.log('formformform',values);
     
    //   }
    // )
    // const formValue = form.getFieldsValue(true)
    // let params = formValue
    let params = {}
    if(courseInfo.id){
      params.epalProductId = courseInfo.id
    }
    console.log('paramsparamsparamsparams',params);
    
    Http.post(Request.financialAdd(),{...params},(obj)=>{
      if(obj.code == 200){
        message.success("申请成功", 2);
      }else{
        message.error(obj.msg || '申请失败')
      }
 })
    setModalVisible(false)
  };
  const handleCancel = () => {
    setModalVisible(false)
  };
  const handleChange = ()=>{
  
  }
  const onChange = (e) => {
    setCheckValue(e.target.value)
  };
  const spectionApplication = () =>{
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return <Form form={form}>{list.map((item,index)=>{
      if(item.type == 'input'){
        return (
            <Col span={24}>
              <Form.Item name={item.name} {...formItemLayout} label={item.label}>
                  <Input
                    placeholder={"请输入姓名"}
                  />
              </Form.Item>
          </Col>
          )
      } else if(item.type == 'TextArea'){
        return (
          <Col span={24}>
            <Form.Item name={item.name} {...formItemLayout} label={item.label}>
                <TextArea
                  placeholder={"请输入姓名"}
                />
            </Form.Item>
        </Col>
        )
      }else if(item.type == 'select'){

        let dictList = getDict() || [];
        console.log(getDict())

        return (
        <Col span={24}>
          <Form.Item name={item.name} {...formItemLayout} label={item.label}>
          <Select defaultValue="" onChange={handleChange}>
            {
              dictList.map((option)=>{
                if("financial_products_type" == option.code){
                  return option.children.map((item)=>{
                      return <Select.Option key={item.dictKey} value={item.dictKey} >{item.dictValue}</Select.Option>
                  })
                }
              })
            }
          </Select>
          </Form.Item>
        </Col>)
      }else if(item.type == 'radio'){
        return (
          <Col span={24}>
            <Form.Item name={item.name} {...formItemLayout} label={item.label}>
              <Radio.Group onChange={onChange} value={checkValue}>
                <Radio value={1}>是</Radio>
                <Radio value={2}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>)
      }else if(item.type == 'time'){
        return (
          <Col span={24} locale={zh_CN}>
            <Form.Item name={item.name} {...formItemLayout} label={item.label}>
                <DatePicker style={{width:'100%'}} locale={zh_CN}/>
            </Form.Item>
          </Col>
         )
          
      }
    })}</Form>
  }
//   const renderBaesInfo = (data) =>{
//     if(data && data.length){
//         return(data.map((item,index)=>{
//             return  <Col span={24} key={index}>  
//                         <span>{item.name}</span>
//                         <span>{item.value}</span>
//                     </Col>
//         }))
        
//     }
// }

        console.log("courseInfo",courseInfo == '')
        const courseList =[
            {
                name:'产品名称',
                value:courseInfo == '' ? courseInfo.trainingName :'退役军人专项贷款-1'
            },
            {
                name:'产品类别',
                value:courseInfo == '' ? courseInfo.major :'退军人就创业贷款'
            },
            {
                name:'发布时间',
                value:courseInfo == '' ? courseInfo.trainingIocations :'2022年10月23日'
            },
            // {
            //     name:'优惠政策',
            //     value:[
            //       {
            //         value:"1、助力退役军人再就业，日息低至0.0008%。",
            //       },
            //       {
            //         value:"2、贷款5年内免息还款",
            //       },
            //       {
            //         value:"3、只服务于退役军人",
            //       },
            //     ]
            // },
          
        ]
        return (
          <div className="FinancialServiceDetails_app">
              <div className="Base_Detils_Box">
                <span>当前位置：创业帮扶 / <span  style={{cursor:'pointer'}} onClick={()=>history.push('/entrance/entrepreneurship')}>创业金融服务 </span>/ </span>
                <span style={{ color: "#3356C5",cursor:'pointer' }}> 创业基金详情</span>
              </div>
              <div className="conBox">
                  <div className="topbox">
                      <div className="right">
                          <div className='courseInfoBox'>
                              {/* <span className='courseName'>{courseInfo.courseName}</span> */}
                              <span className='btnBox'> 
                                  <span className="courseInfoList_top">{courseInfo.epalFinanceDetailsMechanism}</span>
                                  <div>
                                    {/* <Button type='primary' className='leftBtn' onClick={(e)=>{showModal(e)}}>申请贷款</Button> */}
                                    <Button onClick={()=>history.push({pathname:'/entrance/entrepreneurship',params:{activeyKey:4}})}>返回</Button>
                                  </div>
                              </span>
                          </div>
                          
                          <div className='courseInfoList'>
                              <p>产品名称</p>
                              <span>{courseInfo.epalFinanceDetailsName}</span>
                              <p>产品类别</p>
                              <span>{getcodeValue('financial_products_type',courseInfo.epalFinanceDetailsType)}</span>
                              <p>发布时间</p>
                              <span>{moment(courseInfo.epalFinanceDetailsDate).format('YYYY-MM-DD')}</span>
                              <p>优惠政策</p>
                              <span>{courseInfo.epalFinanceDetailsPreferential}</span>
                              <p>产品介绍</p>
                              <span>{courseInfo.epalFinanceDetailsIntroduce}</span>
                              <p>产品图片</p>
                              <div style={{display:'flex',flexWrap:'wrap'}}>{courseInfo.photoList && courseInfo.photoList.length ?courseInfo.photoList.map((item)=>{
                                  return <img src={ item.photoUrl} key={item.id} style={{width:300,margin:5}}></img>
                              }) : '暂无图片'}</div>
                          </div>
                          
                      </div>
                  </div>
              </div>
              <Modal title="申请金融产品" 
                visible={modalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                okText={"确认申请"}
                >
                  {/* {spectionApplication()} */}
                  {`确认申请产品${courseInfo.epalFinanceDetailsName}?`}

              </Modal>
              <ApproveModal ref = {modalRef}/>
          </div>
      );

}